import React from "react";
import {
  GoogleMap,
  useLoadScript,
  type Libraries,
} from "@react-google-maps/api";
import { Typography } from "@c4c-web/ui";
import { useGoogleMap } from "../../../hooks";
import { parseLocationCoordinates } from "./Address.helper";
import { PinInfo } from "./PinInfo";
import type { IGoogleMapUpdatedProps } from "./map.interface";

const libraries: Libraries = ["places"];

export const AddressSelectorMap: React.FC<IGoogleMapUpdatedProps> = ({
  countryOfOperationID = "",
  defaultLocation,
  id,
  setIsSelected,
  setAddressInfo,
  setEmirate,
  setTown,
  searchBarRef,
  setCoordinates,
  town,
  emirate,
  isConfirmAddress,
  formattedAddress,
  onAreaSupportedChange,
  t,
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  const {
    updatedLocation,
    showPin,
    onLoad,
    onUnmount,
    onCenterChanged,
    onDragging,
    isAreaSupported,
  } = useGoogleMap({
    defaultLocation,
    id,
    setIsSelected,
    setAddressInfo,
    setEmirate,
    setTown,
    searchBarRef,
    onAreaSupportedChange,
    setCoordinates,
    formattedAddress,
    countryOfOperationID,
    t,
  });
  const isDraggable = !isConfirmAddress;
  const numericLocation = parseLocationCoordinates(updatedLocation);

  return (
    <>
      {isLoaded ? (
        <GoogleMap
          center={numericLocation}
          mapContainerStyle={{ width: "100%", height: "100%" }}
          onDragEnd={onCenterChanged}
          onDragStart={onDragging}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            disableDefaultUI: true,
            draggable: isDraggable,
            gestureHandling: "greedy",
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
          }}
          zoom={18}
        >
          <PinInfo
            emirate={emirate}
            isAreaSupported={isAreaSupported}
            isConfirmAddress={isConfirmAddress}
            showPin={showPin}
            t={t}
            town={town}
          />
        </GoogleMap>
      ) : (
        <Typography>Loading...</Typography>
      )}
    </>
  );
};
